import { render, staticRenderFns } from "./SecurityBoxForm.vue?vue&type=template&id=23c21c7e&scoped=true"
import script from "./SecurityBoxForm.vue?vue&type=script&lang=js"
export * from "./SecurityBoxForm.vue?vue&type=script&lang=js"
import style0 from "./SecurityBoxForm.vue?vue&type=style&index=0&id=23c21c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c21c7e",
  null
  
)

export default component.exports